import { PageType } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";

import { pathname as postiesKidsPathname } from "scmp-app/pages/posties/kids";
import type { sitemapQuery } from "scmp-app/queries/__generated__/sitemapQuery.graphql";
import type { CustomQueryParameters } from "scmp-app/types/gtm";

import { footerMenuData } from "./data";
import type { FooterMenuData } from "./data";
import { Container, MenuItem, MenuItemBaseLink } from "./styles";

type Props = {
  className?: string;
  postiesFooterQueryParameters: CustomQueryParameters;
};

export const PostiesSitemap: FunctionComponent<Props> = ({
  className,
  postiesFooterQueryParameters,
}) => {
  const data = useLazyLoadQuery<sitemapQuery>(
    graphql`
      query sitemapQuery {
        queue(filter: { name: "posties_menu_read" }) {
          items(first: 14) {
            edges {
              node {
                ... on Section {
                  entityId
                  entityUuid
                  urlAlias
                  name
                }
              }
            }
          }
        }
      }
    `,
    {},
  );

  const readColumn: FooterMenuData = [
    {
      entityId: "",
      entityUuid: "",
      isBold: true,
      isLargeSpacing: true,
      name: "Read",
      query: {
        pageType: PageType.PostiesKids,
      },
      routeType: "Page",
      urlAlias: postiesKidsPathname,
    },
    ...(data.queue?.items?.edges?.map(item => ({
      entityId: item.node.entityId ?? "",
      entityUuid: item.node.entityUuid ?? "",
      name: item.node.name ?? "",
      query: {
        pageType: PageType.PostiesSection,
      },
      routeType: "Section",
      urlAlias: item.node.urlAlias ?? "",
    })) ?? []),
  ];

  return (
    <Container className={className}>
      {[readColumn, ...footerMenuData].map((menuData, dataIndex) => (
        <MenuItem key={dataIndex}>
          {menuData.map((item, index) => (
            <MenuItemBaseLink
              $isBold={item?.isBold}
              $isLargeSpacing={item?.isLargeSpacing}
              key={index}
              pathname={item.urlAlias}
              query={{ ...item.query, ...postiesFooterQueryParameters }}
            >
              {item.name}
            </MenuItemBaseLink>
          ))}
        </MenuItem>
      ))}
    </Container>
  );
};

PostiesSitemap.displayName = "PostiesSitemap";
